import api from "@/lib/api";

export const knowledgeService = {
  entries: (q = "") => api.get("/personalpedia/entries", { params: { q } }).then((r) => r.data.entries),
  ask: (question) => api.post("/personalpedia/ask", { question }).then((r) => r.data),
  learningMap: () => api.get("/personalpedia/learning-map").then((r) => r.data),
  downloadMasteryCertificate: async (topic) => {
    const res = await api.get("/personalpedia/mastery-certificate", { params: { topic }, responseType: "blob" });
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `mastery-${(topic || "topic").replace(/[^a-z0-9]+/gi, "-").toLowerCase()}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
};
